// extracted by mini-css-extract-plugin
module.exports = {"bookmark":"BookmarkContainer_bookmark__1dZm9","crown-animation":"BookmarkContainer_crown-animation__1S1m6","load":"BookmarkContainer_load__3R-Xo"};